import { formatMoney } from 'accounting'

import { digObject } from '@domain-group/javascript-utils'

import {
  Box, Image, ListItem, ListItemWithImage, Text,
} from '@domain-group/suit-theme'

import { OrderItemTaskTypeModel, ProviderModel } from '@models/types'

interface ProviderProps {
  callbacks:{
    editTaskPricing: (customPayload: object) => void,
  },
  orderItemTaskTypes: OrderItemTaskTypeModel[],
  provider: ProviderModel,
  taskPrices: string[],
}

const Provider = (props: ProviderProps) => {
  const {
    callbacks: {
      editTaskPricing,
    },
    orderItemTaskTypes,
    provider,
    taskPrices,
  } = props

  const { phone, title } = provider

  const logoUrl = digObject(provider, 'alternate_logo.thumb')

  return (
    <Box
      flexDirection="column"
      marginBottom="large"
      variant="white"
    >
      <ListItemWithImage
        boxProps={{ marginBottom: 0, border: 'none' }}
        imageComponent={(<Image width={150} url={logoUrl} />)}
      >
        <Box flexDirection="column" padding="large" borderLeft="1px solid" borderColor="lineColor">
          <Text fontSize="medium">{title}</Text>

          <Text fontSize="small" color="bodyFontLightColor" marginTop="medium">
            {phone}
          </Text>
        </Box>
      </ListItemWithImage>

      <Box flexDirection="column">
        {orderItemTaskTypes.map((taskType) => {
          const { title: taskTypeTitle, short_name, id } = taskType
          // @ts-expect-error TS2538
          const price = taskPrices ? taskPrices[short_name] : ''

          return (
            <ListItem
              boxProps={{
                borderTop: '1px solid',
                borderColor: 'lineColor',
                justifyContent: 'space-between',
                padding: 'large',
              }}
              key={id}
              onClick={() => editTaskPricing({ provider, taskType })}
              showAngleIcon
            >
              <Text fontSize="small">{taskTypeTitle}</Text>

              {!!price && (
                <Text fontSize="small" color="bodyFontLightColor">
                  {formatMoney(price)}
                </Text>
              )}
            </ListItem>
          )
        })}
      </Box>
    </Box>
  )
}

export default Provider
